import { useCallback, useRef } from "react";

export const useTimeHook = ({ duration }) => {
    const ref = useRef()

    const delay = useCallback((fun) => {
        reset()
        ref.current = setTimeout(() => {
            fun?.()
        }, duration);
    }, [])

    const reset = useCallback(() => {
        ref.current && clearTimeout(ref.current)
    }, [])

    return {
        delay,
        reset
    }
}